import React, { useState, useEffect } from "react";
import Base from "../../Config/Base";
import { API_BASE_CRM_URL, API_BASE_URL } from "../../Config/Config";
import { Link } from "react-router-dom";
import "./blur.css";
import "../../Config/loading.css";
import { Footer } from "../footer/footer";
export default function Dashboard() {
  const [MisUserDetails, SetUserDetails] = useState([]);
  const [dashboardDatas, setDashboardDatas] = useState([]);
  const [customerData, SetcustomerData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [ordercount, SetorderCount] = useState([]);
  const [products, setProducts] = useState([]);
  const [brandData, setbrandData] = useState([]);

  useEffect(() => {
    const MisUserDetailsSession = JSON.parse(
      sessionStorage.getItem("MisUserDetails") ||
        localStorage.getItem("MisUserDetails"),
    );
    SetUserDetails(MisUserDetailsSession);
  }, []);

  const [dashboardData, SetDashboardData] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}MobileSVC/getCustomer?OrgId=${MisUserDetails?.OrgId}&CustomerId=0`,
        );
        const data = await response.json();
        console.log(data);
        if (data.Status) {
          SetcustomerData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          SetcustomerData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    if (MisUserDetails && MisUserDetails?.OrgId) {
      fetchData();
    }
  }, [MisUserDetails?.OrgId]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}MobileSVC/getBrands?OrgId=${MisUserDetails?.OrgId}`,
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        if (data.Status) {
          setbrandData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setbrandData([]);
        }
      } catch (error) {
        console.error("Error fetching datasssss:", error);
      } finally {
        setLoading(false);
      }
    };
    if (MisUserDetails?.OrgId) {
      fetchData();
    }
  }, [MisUserDetails?.OrgId]);

  const currentMonthName = new Date().toLocaleString("default", {
    month: "long",
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}MobileSVC/getCategories?OrgId=${MisUserDetails?.OrgId}`,
        );
        const data = await response.json();
        console.log(data);
        if (data.Status) {
          setCategoriesData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setCategoriesData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (MisUserDetails && MisUserDetails?.OrgId) {
      fetchData();
    }
  }, [MisUserDetails?.OrgId]);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}Product/GetStoreProducts`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              OrgId: MisUserDetails.OrgId,
              Id: "0",
              CategoryId: "0",
              BarCode: "0",
              IsActive: 1,
              ProductId: 0,
              StoreId: 0,
              IsForSale: 1,
              UserId: MisUserDetails.UserId,
              Type: 0,
            }),
          },
        );

        const data = await response.json();
        console.log(data);
        if (Array.isArray(data.ResultData)) {
          setProducts(data.ResultData);
          setLoading(false);
        } else {
          console.error("API response is not an array:", data);
          setProducts([]);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    if (MisUserDetails?.OrgId) {
      fetchProducts();
    }
  }, [MisUserDetails.OrgId]);

  useEffect(() => {
    setLoading(true);

    const fetchDashboardData = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}MobileSVC/getDashboardCounts?OrgId=${MisUserDetails?.OrgId}&UserId=${MisUserDetails?.UserId}`,
        );

        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        setDashboardDatas(data.ResultData[0]);
        console.log(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching dashboard data:", error.message);
      }
    };
    if (MisUserDetails && MisUserDetails?.OrgId) {
      fetchDashboardData();
    }
  }, [MisUserDetails]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}Dashboard/InventoryDashboard?OrgId=${MisUserDetails?.OrgId}&StoreId=0&UserId=${MisUserDetails?.UserId}`,
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data.RecentSuppliers?.[0]?.TotalSupplierCount);
        console.log(data);

        if (data && Object.keys(data).length > 0) {
          SetDashboardData(data);
          SetorderCount(data.mostOrderedProducts);
        } else {
          console.error("Fetched data is not as expected:", data);
          SetDashboardData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (MisUserDetails?.OrgId) {
      fetchData();
    }
  }, [MisUserDetails]);

  useEffect(() => {
    console.log("Updated Dashboard Data:", dashboardData);
  }, [dashboardData]);

  useEffect(() => {
    console.log("Updated Dashboard Data:", ordercount);
  }, [ordercount]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}MobileSVC/getBrands?OrgId=${MisUserDetails?.OrgId}`,
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        if (data.Status) {
          setbrandData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setbrandData([]);
        }
      } catch (error) {
        console.error("Error fetching datasssss:", error);
      } finally {
        setLoading(false);
      }
    };
    if (MisUserDetails?.OrgId) {
      fetchData();
    }
  }, [MisUserDetails?.OrgId]);

  const formatNumber = (num) => {
    if (num >= 10_000_000) return (num / 10_000_000).toFixed(1) + "Cr";
    if (num >= 100_000) return (num / 100_000).toFixed(1) + "L";
    if (num >= 1_000) return (num / 1_000).toFixed(1) + "K";
    return num;
  };

  return (
    <Base>
      {loading ? (
        <p className="laoding-text">
          <div className="containers">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </p>
      ) : (
        ""
      )}
      <h4 className="mb-2">👋 Hi {MisUserDetails?.UserName}</h4>
      <div className="row">
        <div className="col-xl-3 col-sm-6 col-6 d-flex">
          <Link
            to="/stores"
            className="dash-count "
            style={{ backgroundColor: "#07074a" }}
          >
            <div className="dash-counts">
              <h4>
                {dashboardDatas.TotalStores ? dashboardDatas?.TotalStores : 0}
              </h4>

              <div style={{ textDecoration: "none", width: "100%" }}>
                <h5>Stores</h5>
              </div>
            </div>
            <div className="dash-imgs">
              <i class="fa-solid fa-store"></i>
            </div>
          </Link>
        </div>
        <div className="col-xl-3 col-sm-6 col-6 d-flex">
          <Link
            to="/sale"
            className="dash-count das1"
            style={{ backgroundColor: "#1b6d35" }}
          >
            <div className="dash-counts">
              <h4>
                {dashboardDatas.MonthOrderTotal
                  ? formatNumber(dashboardDatas?.MonthOrderTotal)
                  : 0}
              </h4>
              <div style={{ textDecoration: "none", width: "100%" }}>
                <h5> {currentMonthName} sale</h5>
              </div>
            </div>
            <div className="dash-imgs">
              <i className="fa-solid fa-chart-simple"></i>
            </div>
          </Link>
        </div>
        <div className="col-xl-3 col-sm-6 col-6 d-flex">
          <Link
            to="/todaysale"
            className="dash-count das2"
            style={{ backgroundColor: "#0abddc" }}
          >
            <div className="dash-counts">
              <h4>
                {dashboardDatas && dashboardDatas.TodayOrderTotal
                  ? formatNumber(dashboardDatas?.TodayOrderTotal)
                  : 0}
              </h4>
              <div>
                <h5> Today sale</h5>
              </div>
            </div>
            <div className="dash-imgs">
              <i class="fa-solid fa-chart-line"></i>
            </div>
          </Link>
        </div>
        <div className="col-xl-3 col-sm-6 col-6 d-flex">
          <Link
            to="/refund"
            className="dash-count das3"
            style={{ backgroundColor: "#0038ff" }}
          >
            <div className="dash-counts">
              <h4>
                {dashboardDatas && dashboardDatas.RefundAmount
                  ? formatNumber(dashboardDatas?.RefundAmount)
                  : 0}
              </h4>
              <div>
                <h5>Refunds</h5>
              </div>
            </div>
            <div className="dash-imgs">
              <i class="fa-solid fa-money-bill"></i>
            </div>
          </Link>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-4 col-md-4 mb-2">
          <Link to="/products">
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                {/* <i
                  className="fa-solid fa-shop fa-xl mb-1"
                  style={{ color: "#1629bc" }}
                ></i> */}
                <i
                  className="bi bi-boxes fs-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              >
                {products?.length ?? 0}
              </div>
            </div>
          </Link>

          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Products
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2">
          <Link to="/suppliers">
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="bi bi-truck fs-1 mb-1 "
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              >
                {dashboardDatas.TotalSuppliers
                  ? dashboardDatas?.TotalSuppliers
                  : 0}
              </div>
            </div>
            <div className="text-center">
              <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
                Suppliers
              </h6>
            </div>
          </Link>
        </div>
        <div className="col-4 col-md-4 mb-2">
          <Link to="/recentstock">
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-layer-group fa-xl mb-1 "
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              >
                {dashboardData?.recentStockRequests?.[0]
                  ?.TotalPurchaseRequestCount ?? 0}
              </div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Recent Stock
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2">
          <Link to="/pendingindent">
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="bi bi-clock-history fs-1 mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              >
                {dashboardData?.pendingIndents?.length > 0
                  ? (dashboardData.pendingIndents[0]?.TotalCount ?? 0)
                  : 0}
              </div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Pending Indent
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2">
          <Link to="/mostorder">
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="bi bi-cart-plus  fs-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              >
                {/* {dashboardData && dashboardData.expiredProducts ? dashboardData.expiredProducts : 0} */}
                {ordercount?.length ?? 0}
              </div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Most Ordered
            </h6>
          </div>
        </div>
        {/* <div className="col-4 col-md-4 mb-2">
          <Link to="/brands">
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="bi bi-tags fs-1 mb-2"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              >
                {brandData?.length ?? 0}
              </div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Brands
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2">
          <Link to="/Categories">
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-list fa-2x mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              >
                {categoriesData?.length ?? 0}
              </div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Categories
            </h6>
          </div>
        </div> */}
        <div className="col-4 col-md-4 mb-2">
          <Link to="/orders">
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="bi bi-cart fs-1 mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              >
                {dashboardDatas.TotalOrdersCount
                  ? dashboardDatas?.TotalOrdersCount
                  : 0}
              </div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Orders
            </h6>
          </div>
        </div>
      </div>

      <hr></hr>
      <h3 style={{ marginLeft: "15px" }}>Reports</h3>
      <br></br>
      <div className="row mb-2">
        <div className="col-4 col-md-4 mb-2">
          <Link to="/salebystore" state={{ reportId: 203 }}>
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-store fa-2x mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              ></div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Sale by Store
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2">
          <Link to="/paymenttype" state={{ reportId: 204 }}>
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-money-bill fa-2x mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              ></div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Sale by payment
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2">
          <Link to="/salebyemploye" state={{ reportId: 208 }}>
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-user fa-2x mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              ></div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Sale by Employee
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2">
          <Link to="/salebycategory" state={{ reportId: 202 }}>
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-list-check fa-2x mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              ></div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Sale by Categories
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2">
          <Link to="/salebyproduct" state={{ reportId: 201 }}>
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-shop fa-2x mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              ></div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Sale by Product
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2">
          <Link to="/salebygst" state={{ reportId: 206 }}>
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-file-invoice fa-2x mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              ></div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Sale by Gst
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2">
          <Link to="/salebygstdetails" state={{ reportId: 207 }}>
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-file-invoice fa-2x mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
              <div
                className="mt-1"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#1629bc",
                }}
              ></div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Sale by GstDetails
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2 d-none">
          <Link to="/weekly-sales" state={{ reportId: 603 }}>
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-calendar-week fa-2x mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Weekly Sales
            </h6>
          </div>
        </div>
        <div className="col-4 col-md-4 mb-2 ">
          <Link to="/today-transactions" state={{ reportId: 210 }}>
            <div className="card border-0 shadow-sm rounded-3 mb-3 text-center">
              <div
                className="card-body d-flex flex-column align-items-center justify-content-center p-3"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f0f3ff",
                  borderRadius: "50%",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-calendar-day fa-2x mb-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </div>
            </div>
          </Link>
          <div className="text-center">
            <h6 className="font-weight-bold mb-0" style={{ color: "#555" }}>
              Today's Transactions
            </h6>
          </div>
        </div>
      </div>
      <br></br>
      <br></br>
      <br></br>
      <Footer></Footer>
    </Base>
  );
}
